import * as t from "io-ts";
import { BankAccount } from "./BankAccount";
import { BankAccountType } from "./BankAccountType";
import { CompanyType } from "./CompanyType";
import { LimitedCompanyInfo } from "./LimitedCompanyInfo";
import { SoleTraderInfo } from "./SoleTraderInfo";
import { VerificationStatus } from "./VerificationStatus";

export const TraderDetails = t.intersection([
  t.type({
    company_type: CompanyType,
    bank_type: BankAccountType,
    bank_account: BankAccount,
  }),
  t.partial({
    limited_company_info: LimitedCompanyInfo,
    sole_trader_info: SoleTraderInfo,
    bank_report: t.string,
    bank_verification: VerificationStatus,
  }),
]);

export interface TraderDetails {
  company_type: CompanyType;
  limited_company_info?: LimitedCompanyInfo;
  sole_trader_info?: SoleTraderInfo;
  bank_type: BankAccountType;
  bank_account: BankAccount;
  bank_report?: string;
  bank_verification?: VerificationStatus;
}
